import { render } from "./LoadingTranslation.vue?vue&type=template&id=4bf86fcb&scoped=true"
import script from "./LoadingTranslation.vue?vue&type=script&lang=js"
export * from "./LoadingTranslation.vue?vue&type=script&lang=js"

import "./LoadingTranslation.vue?vue&type=style&index=0&id=4bf86fcb&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf86fcb"]])

export default __exports__